import { BasicFeePayload,
  BonusDataPayload,
  BonusPercentagePayload
} from '@/app/ui/controllers/PayrollController'
import {
  CreatePayrollRequestInterface,
  UpdatePayrollRuleRequestInterface,
} from '@/data/payload/contracts/PayrollRequest'

export class CreatePayrollApiRequest implements CreatePayrollRequestInterface {
  public startDate?: string

  constructor(startDate?: string) {
    this.startDate = startDate
  }

  public toPayload(): string {
    const data = {
      start_date: this.startDate,
    }
    return JSON.stringify({
      ...data,
    })
  }
}

export class UpdatePeriodBasicFeeApiRequest
  implements UpdatePayrollRuleRequestInterface {
  public rules?: BasicFeePayload

  constructor(rules?: BasicFeePayload) {
    this.rules = rules
  }

  public toPayload(): string {
    const data = {
      rules: this.rules,
    }

    return JSON.stringify({
      ...data,
    })
  }
}

export class UpdatePeriodWithdrawApiRequest implements UpdatePayrollRuleRequestInterface {
  public rules?: {
    min_payout_amount?: number
    min_saldo?: number
    payout_fee?: number
  }

  constructor(rules?: {
    min_payout_amount?: number
    min_saldo?: number
    payout_fee?: number
  }) {
    this.rules = rules
  }

  public toPayload(): string {
    const data = {
      rules: this.rules,
    }

    return JSON.stringify({
      ...data,
    })
  }
}

export class UpdatePeriodBonusFeeApiRequest implements UpdatePayrollRuleRequestInterface {
  public rules?: {
    bonus_recipient?: string[],
    captain_bonus?: string[],
    captain_bonus_fee?: number,
    captain_bonus_options?: string[],
    insurance?: boolean,
    performance_bonus?: boolean,
    performance_bonus_data?: BonusDataPayload[],
    percentage_bonus?: boolean,
    percentage_bonus_data?:BonusPercentagePayload[],
    pickup_bonus?: boolean,
    pickup_bonus_data?: BonusDataPayload[],
  }

  constructor(rules?: {
    bonus_recipient?: string[],
    captain_bonus?: string[],
    captain_bonus_fee?: number,
    captain_bonus_options?: string[],
    insurance?: boolean,
    performance_bonus?: boolean,
    performance_bonus_data?: BonusDataPayload[],
    percentage_bonus?: boolean,
    percentage_bonus_data?: BonusPercentagePayload[],
    pickup_bonus?: boolean,
    pickup_bonus_data?: BonusDataPayload[],
  }) {
    this.rules = rules
  }

  public toPayload(): string {
    const data = {
      rules: this.rules,
    }

    return JSON.stringify({
      ...data,
    })
  }
}
